import { routerGetCall } from '../../axios';

const getPartnersApi = (state, params) => {
    const url = `/accounts/commission-numbers`;
    return routerGetCall(state, url, params);
};
export default { getPartnersApi };
